import { DoubleCheckIcon, SlotSevenIcon } from '@repo/icons';
import { Button } from '@repo/ui/button';
import { useTranslations } from 'next-intl';
import Link, { UnStyledLink } from '@/components/common/link';
import { type PaymentTypes } from '@/server-actions/payment-methods';

interface SuccessMessageProps {
  paymentType: PaymentTypes;
  title: React.ReactNode;
  subTitle: React.ReactNode;
}

const SuccessMessage = ({ paymentType, title, subTitle }: SuccessMessageProps) => {
  const t = useTranslations(paymentType);

  return (
    <div className="flex size-full flex-col items-center justify-center space-y-10 text-center">
      <div
        className="flex w-full flex-col items-center justify-center gap-y-3 vt-colors-statuses-success-strong"
        data-testid="success-message"
      >
        <div className=" flex h-10 w-10 items-center justify-center rounded-full text-center vt-surface-darker-bg">
          <DoubleCheckIcon />
        </div>
        <h1 className="vt-font-highlight-font-family vt-text-size-biggest sm:vt-text-size-biggest-sm">{title}</h1>
        <h2 className="vt-text-size-medium sm:vt-text-size-medium-sm">{subTitle}</h2>
      </div>
      <Link
        className="underline vt-text-size-medium sm:vt-text-size-medium-sm"
        href={`/account/transactions/${paymentType}`}
      >
        {t('go-to-payment-history')}
      </Link>
      <div className="flex items-center justify-center self-center">
        <Button
          variant="secondary"
          asChild
        >
          <UnStyledLink
            href="/casino/lobby"
            className="flex items-center gap-x-2"
          >
            <SlotSevenIcon className="size-5" />
            <span>{t('go-to-lobby')}</span>
          </UnStyledLink>
        </Button>
      </div>
    </div>
  );
};

export default SuccessMessage;
